import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExcelComponent } from './excel.component';
import { FileUploadModule } from 'primeng/fileupload';
import { ButtonModule } from 'primeng/button';
import {BlockUIModule} from 'primeng/blockui';

@NgModule({
  declarations: [ExcelComponent],
  imports: [
    CommonModule,
    FileUploadModule,
    ButtonModule,
    BlockUIModule
  ]
})
export class ExcelModule { }
